export default __webpack_public_path__ + "assets/images/a2e328868e73c8b5dc7e6dde20ebf9ea.png";